import { render } from "./Defender.vue?vue&type=template&id=3bed95c0"
import script from "./Defender.vue?vue&type=script&lang=js"
export * from "./Defender.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/player/Defender.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bed95c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bed95c0', __exports__)) {
    api.reload('3bed95c0', __exports__)
  }
  
  module.hot.accept("./Defender.vue?vue&type=template&id=3bed95c0", () => {
    api.rerender('3bed95c0', render)
  })

}


export default __exports__